<!-- 各ストアの中身を表示して確認する管理画面 -->
<script>
  import StoreJsonViewer from '../components/StoreJsonViewer.svelte'

  import {
    clientList$,
    memberList$,
    yokotaMemberList$,
    reportHistory$,
    projectHistory$,
    deviceId$,
    role$,
    reporterName$,
  } from '../store'
</script>

<StoreJsonViewer label="クライアント リスト" json={$clientList$} />
<StoreJsonViewer label="メンバー リスト" json={$memberList$} />
<StoreJsonViewer label="横田工業 メンバー リスト" json={$yokotaMemberList$} />
<StoreJsonViewer label="作業報告 履歴" json={$reportHistory$} />
<StoreJsonViewer label="工事 履歴" json={$projectHistory$} />
<StoreJsonViewer label="デバイス ID" json={$deviceId$} />
<StoreJsonViewer label="ロール" json={$role$} />
<StoreJsonViewer label="報告者名" json={$reporterName$} />
